import styled from 'styled-components'
import { themeColor, themeFontFamily } from 'LibNeo'

export const NotifyWrapper = styled.div`
	bottom: 80px;
	position: absolute;
	margin-left: auto;
	margin-right: auto;
	left: 0;
	right: 0;
	z-index: 666666;
	width: fit-content;
    background-color: ${themeColor('gray', 9)};
	border-radius: 6px;
    padding: 12px 20px;
	color: ${themeColor('gray', 3)};
	font-size: 14px;
	line-height: 20px;
	font-family: ${themeFontFamily('SBSansText')};
  	animation: opacityAnimation .2s;
    animation-fill-mode: forwards;

  @keyframes opacityAnimation {
    from {
      opacity: 0
    }
    to {
      opacity: 1
    }
  }
}
`
